
    <form [formGroup]="form" (ngSubmit)="submit($event)">
      <h5>FIAT Deposit</h5>
      <div class="columns">
        <div class="form-group">
          <label>Amount to deposit</label>
          <input
            type="number"
            formControlName="amount"
            class="input"
            maxlength="25"
            name="amount-to-withdraw"
            required
            placeholder="00.00"
          />
        </div>
        <div class="form-group">
          <label>Currency</label>
          <app-form-select [options]="currencies" formControlName="currency"></app-form-select>
        </div>
      </div>

      <p>If asked for ETH wallet please make sure you provide this one:</p>

      <div class="deposit-address-wrap">
        <div class="address" [cbContent]="address" ngxClipboard>{{ address }}</div>
        <div class="deposit-right-flex">
          <button type="button" class="copy-address" [disabled]="!address" ngxClipboard [cbContent]="address">
            <i class="fal fa-copy"></i>
          </button>
        </div>
      </div>

      <button class="btn btn-primary" [disabled]="form.invalid" type="submit" ngxClipboard [cbContent]="address">
        Next step
      </button>

      <a [href]="url" target="_blank" #anchorElement class="anchor">Open in new tab.</a>

      <p>
        By clicking "Next step" you will be redirected to our partners (Changelly) website where you will be able to
        purchase <i>DAI</i> token.
      </p>
      <p><i>DAI</i> balance will be visible as USD in our platform.</p>
      <p><i>Changelly</i> may ask KYC verification before making deposits.</p>

      <app-deposit-bonus-notice></app-deposit-bonus-notice>
    </form>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/deposit/fiat-deposit.component.ts.FiatDepositComponent.html